import HashLoader from 'react-spinners/HashLoader';

export default function FullLoader() {
  return (
    <div className="loader-background">
      <span>
        <HashLoader size={150} color={'#000'} />
      </span>
    </div>
  );
}
